import React from "react";
import {
  Stepper,
  Step,
  StepTitle,
  StepDescription,
  StepIndicator,
  StepSeparator,
  StepStatus,
  Box,
  Icon,
} from "@chakra-ui/react";
import { StarIcon } from "@chakra-ui/icons";
import { IoIosUnlock } from "react-icons/io";
import { LuBellRing } from "react-icons/lu";
import { FREE_TRIAL_DAYS} from "@/lib/domainConstants";

const FreeTrialStepper: React.FC = () => {
  const steps = [
    {
      title: "Today: Start learning",
      description:
        "Unlock your custom learning plan, subtitle clicking, lesson activities and more.",
    },
    {
      title: `In ${FREE_TRIAL_DAYS - 1} days: Reminder`,
      description: "We'll send you a reminder that your free trial is ending.",
    },
    {
      title: `In ${FREE_TRIAL_DAYS} days: Billing Starts`,
      description:
        `You'll be charged in ${FREE_TRIAL_DAYS} days unless you cancel anytime before then.`,
    },
  ];

  const currentStepIndex = 1; // Assuming this is the current step index

  return (
    <Stepper
      index={currentStepIndex}
      paddingX={4}
      paddingLeft={8}
      orientation="vertical"
      height="auto"
      minHeight={64}
      width={"100%"}
      gap="0"
      fontFamily={"Inter, sans-serif"}
      fontSize="base"
      justifyItems={"center"}
    >
      {steps.map((step, index) => {
        const status =
          index < currentStepIndex
            ? "complete"
            : index === currentStepIndex
            ? "active"
            : "incomplete";

        return (
          <Step key={index} style={{ justifyContent: "center" }}>
            <StepIndicator
              style={{
                backgroundColor:
                  status === "complete" || status === "active"
                    ? "var(--color-blue)"
                    : "",
                borderColor:
                  status === "incomplete"
                    ? "var(--color-grey-light)"
                    : "var(--color-blue)",
              }}
            >
              <StepStatus
                complete={
                  <Icon as={IoIosUnlock} textColor="white" boxSize={5} />
                }
                active={<Icon as={LuBellRing} textColor="white" boxSize={5} />}
                incomplete={<StarIcon textColor="var(--color-grey)" />}
              />
            </StepIndicator>

            <Box flexShrink="2" textAlign="left">
              <StepTitle className="text-2xl">{step.title}</StepTitle>
              <StepDescription className="text-base">{step.description}</StepDescription>
            </Box>

            <StepSeparator
              style={{
                width: "6px",
                height: "full",
                left: "13px",
                justifySelf: "center",
                backgroundColor:
                  status === "complete"
                    ? "var(--color-blue)"
                    : "var(--color-grey-light)",
              }}
            />
          </Step>
        );
      })}

      <StepSeparator
        style={{
          width: "6px",
          height: "60px",
          left: "13px",
          justifySelf: "center",
          backgroundColor: "var(--color-grey-light)",
          position: "relative",
          marginTop: "-20px",
          borderBottomLeftRadius: "3px !important",
          borderBottomRightRadius: "3px !important",
          borderRadius: "0 0 3px 3px !important",
        }}
      />
    </Stepper>
  );
};

export default FreeTrialStepper;
